<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  @font-face{
    font-family: 'AntenaBeta';
    src: url("../static/webfonts/AntennaBeta/AntenBetReg.ttf");
  }

  @font-face {
    font-family: 'Myriad';
    src: url("../static/webfonts/Myriad/MyriadProRegular.ttf");
  }

  body {
    /*background-color: #E9ECEF;*/
    background-color: #1f1f21;
    color: #FFF;
    font-family: 'Myriad';
    /* font-family: 'AntenaBeta'; */
    font-size: 0.8rem;
    overflow-x: hidden;
  }

  hr {
    border-color: #FFF;
  }

  a:hover {
    text-decoration: none;
  }

  img {
    width: 100%;
  }

  .letraDelTitulo {
    font-family: 'AntenaBeta';
  }

  .overwrapDeBotones {
    white-space: inherit;
  }

  .area {
    background-color: #323335;
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
  }

  .area-claro {
    background-color: #D9D9D9;
    box-shadow: 0px 3px 10px 2px #323335;
    padding: 25px;
  }

    .area-claro hr {
      border-color: #161616;
    }

  .grid-container{
    display: grid;
  }

  .menu-l {
    /*background-color: #222222;*/
    background-color: #2e2f31 !important;
    top: 60px;
    bottom: 0;
    left: 0;
    position: fixed;
    width: 200px;
    color: #FFF;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    align-content: flex-start;
    z-index: 9;
    box-shadow: 0px 20px 20px 6px #161616;
  }

    .menu-l h6 {
      padding-left: 15px;
      margin: 15px 0 10px;
    }

    .menu-l a {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 26px;
      transition: all .5s;
      padding-bottom: 1.2vh;
      padding-top: 1.29vh;
      position: relative;
      margin-bottom: 1vh;
    }

    .menu-l ul {
      position: absolute;
      top: 0;
      left: 200px;
      width: 0;
      background-color: #2e2f31;
      padding-left: 0;
      opacity: 0;
      transition: opacity .3s;
      overflow: hidden;
    }

    .menu-l li {
      list-style: none;
      text-align: left;
    }

      .menu-l li:hover {
        background-color: #333333;
      }

      .menu-l li > a {
        color: #FFF;
        padding: 0;
        margin-bottom: 0;
        transition: all 0s;
      }

    .menu-l a:hover li > a {
      padding: 10px 15px;
    }

    .menu-l a:hover ul {
      opacity: 1;
      width: 260px;
    }


    .menu-l i {
      color: rgba(255,255,255,0.6);
      font-size: 20px;
      transition: all .3s;
      width: 30px;
    }

    .menu-l a:hover {
      text-decoration: none;
      background-color: #333333;
    }

      .menu-l a:hover h5, .menu-l a:hover i {
        transform: scale(1.1);
      }

    .menu-l h5 {
      font-size: 16px;
      margin-bottom: 0;
      padding-left: 10px;
      color: #FFF;
      transition: all .3s;
    }
    .menu-s {
    /*background-color: #222222;*/
    bottom: 0;
    left: 0;
    width: 100px;
    color: #FFF;
    flex-wrap: wrap;
    text-align: center;
    align-content: flex-start;
    z-index: 9;
  }

    .menu-s h6 {
      padding-left: 15px;
      margin: 15px 0 10px;
    }

    .menu-s a {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 26px;
      transition: all .5s;
      padding-bottom: 1.2vh;
      padding-top: 1.29vh;
      position: relative;
      margin-bottom: 1vh;
    }

    .menu-s ul {
      position: absolute;
      top: 15px;
      left: 0px;
      width: 0;
      background-color: #2e2f31;
      padding-left: 0;
      opacity: 0;
      transition: opacity .3s;
      overflow: hidden;
    }

    .menu-s li {
      list-style: none;
      text-align: left;
    }

      .menu-s li:hover {
        background-color: #333333;
      }

      .menu-s li > a {
        color: #FFF;
        padding: 0;
        margin-bottom: 0;
        transition: all 0s;
      }

    .menu-s a:hover li > a {
      padding: 10px 15px;
    }

    .menu-s a:hover ul {
      opacity: 1;
      width: 260px;
    }


    .menu-s i {
      color: #FFF;
      font-size: 20px;
      transition: all .3s;
      width: 30px;
    }

    .menu-s a:hover {
      text-decoration: none;
      background-color: #333333;
    }

      .menu-s a:hover h5, .menu-s a:hover i {
        transform: scale(1.1);
      }

    .menu-s h5 {
      font-size: 16px;
      margin-bottom: 0;
      padding-left: 10px;
      color: #FFF;
      transition: all .3s;
    }
  .content-area {
    width: calc(100vw - 200px);
    min-height: calc(100vh - 60px);
    background-color: #202124;
    margin-top: 60px;
    margin-left: 200px;
    padding: 30px;
  }

  .container-medium {
    width: 100vw;
    margin-left: 10vw;
    margin-right: 10vw;
  }

  .nav-tabs .nav-link {
    background-color: #3a3a3d;
    color: #FFF;
  }

    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
      background-color: #535356;
      color: #202124;
    }

  .tab-pane {
    width: 100% !important;
  }

  .form-group-h {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }

    .form-group-h label {
      white-space: nowrap;
      /*min-width: 140px;*/
      margin-bottom: 0;
      padding-right: 10px;
    }

  .form-control {
    background-color: #504f54;
    border: none;
    color: #FFF;
    font-size: 0.9rem;
    padding: 0 .75rem;
    height: calc(2rem);

  }

    .form-control:disabled {
      opacity:0.5;
      background-color: #504f54;
      color: #FFF;
    }

  .form-control-claro {
    background-color: #FFF;
    border: none;
    color: #504f54;
    font-size: 0.9rem;
    padding: 0 .75rem;
    height: calc(2rem);
  }

    .form-control-claro:disabled {
      opacity: 0.5;
      background-color: #FFF;
      color: #504f54;
    }

  input[type=date]::-webkit-inner-spin-button, input[type=time]::-webkit-inner-spin-button {
    display: none;
  }

  .btn-primary {
    background-color: #666666;
    border: none;
    padding: .375rem 2rem;
  }

  .modal-content {
    background-color: #323335;
  }

  .modal-header .close {
    color: #FFF;
  }
  .tableSelect {
    color: #504f54;
    background-color: transparent;
    border: solid;
    border-width: 1px;
  }

  .padding-div-low {
    padding-top: 40px;
    padding-bottom: 20px;
  }

  a {
    cursor: pointer;
    text-decoration: none;
  }

  td {
    color: black;
  }


  /*  EFECTOS DE TRANSICIONES */
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  /****    DATE-PICKER   ****/
  .vdp-datepicker
  {
      min-width: 30%;
      max-width: 80%;
      width: auto;
  }
  .vdp-datepicker__calendar{
      color:black ;
  }
  span.day-header{
      font-size: 0.9rem !important;
  }
  .vdp-datepicker__calendar .cell.selected {
    background: rgb(109, 110, 110) !important;
  }
  .vdp-datepicker__calendar .cell.highlighted {
    background: #afb0b1 !important;
  }
  .vdp-datepicker__calendar .cell.selected.highlighted {
    background: rgb(109, 110, 110) !important;
  }
  .vdp-datepicker__calendar .cell.disabled{
    color:#666666 !important;
  }
  .vdp-datepicker__calendar .cell.selected.disabled {
    color:#333333 !important;
  }
  .vdp-datepicker>.input-group>.form-control[readonly]{
    background-color: #504f54;
    border: none;
    color: #FFF;
    font-size: 0.9rem;
    padding: 0 .75rem;
    height: calc(2rem);
  }
  .vdp-datepicker__calendar .cell:not(.disabled):not(.day-header):not(.blank):hover {
    border-color: #1F1F21 !important;
  }
  .day__month_btn {
    font-size: 0.9rem !important;
  }
  .vdp-datepicker__calendar-button>.input-group-text{
    border:none;
    background-color: #666666;
    color: #FFF;
  }
  .vdp-datepicker__calendar-button>.input-group-text:hover{
      background-color: #999999;
      color:black;
  }

  @media(max-width: 991px) {
    .content-area {
      width: calc(100vw - 80px);
      margin-left: 80px;
    }
  }

  .multiselect__placeholder {
  display: inline-block !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
}


.multiselect.invalid .multiselect__tags {
  border: 1px solid #ff1e1e !important;
}


.multiselect__option--highlight {
  background: #42505c !important;
}

.multiselect__option--highlight:after {
  background: #42505c !important;
}

.multiselect__tags {
  padding: 5px !important;
  min-height: 10px;
}

.multiselect__placeholder{
  margin-left: 10px;
  margin-top: 2px;
}

.multiselect__tag {
  background: #f0f0f0 !important;
  border: 1px solid rgba(60, 60, 60, 0.26) !important;
  color: black !important;
  margin-bottom: 0px !important;
  margin-right: 5px !important;
}

.multiselect__tag-icon:after {
  color: rgba(60, 60, 60, 0.5) !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #f0f0f0 !important;
}

.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: red !important;
}

</style>


// WEBPACK FOOTER //
// src/App.vue